module.exports = __webpack_public_path__ + "img/Anniversary35A.0e335bbe.png";